import { ArrowLeft, ClipboardList } from 'lucide-react';
import { useContext, useEffect, useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import "../../../../assets/css/screens/customer/dashboard/myjobs/MyJobs.css";
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';

import Lightbox from '../../../../components/customer/dashboard/myjobs/lightbox/LightBox';
import ReviewModal from '../../../../components/customer/dashboard/myjobs/reviewmodal/ReviewModal';
import DisputeModal from '../../../../components/customer/dashboard/myjobs/disputemodal/DisputeModal';
import BidsModal from '../../../../components/customer/dashboard/myjobs/bidsmodal/BidsModal';
import JobCard from '../../../../components/customer/dashboard/myjobs/jobcard/JobCard';
import echo from '../../../../config/echo';
import MyJobsSkeleton from "../../../../components/JobCardSkeleton";

/* ══════════ CONSTANTS ══════════ */
const status = {
  pending: { label: 'Pending', color: '#f59e0b', bg: 'rgba(245,158,11,0.10)' },
  assigned: { label: 'Assigned', color: '#8b5cf6', bg: 'rgba(139,92,246,0.10)' },
  in_progress: { label: 'In Progress', color: '#0491e1', bg: 'rgba(4,145,225,0.10)' },
  awaiting_confirmation: { label: 'Awaiting Confirmation', color: '#06b6d4', bg: 'rgba(6,182,212,0.10)' },
  completed: { label: 'Completed', color: '#10b981', bg: 'rgba(16,185,129,0.10)' },
  raise_dispute: { label: 'Dispute Raised', color: '#f97316', bg: 'rgba(249,115,22,0.10)' },
  dispute_frozen: { label: 'Dispute Frozen', color: '#ef4444', bg: 'rgba(239,68,68,0.10)' },
  cancelled: { label: 'Cancelled', color: '#ef4444', bg: 'rgba(239,68,68,0.10)' },
  refunded: { label: 'Refunded', color: '#10b981', bg: 'rgba(16,185,129,0.10)' },
  admin_review: { label: 'Admin Review', color: '#f59e0b', bg: 'rgba(245,158,11,0.10)' },
  bid_sent: { label: 'Bids Received', color: '#0491e1', bg: 'rgba(4,145,225,0.10)' },
};

const TABS = ['All', 'pending', 'bid_sent', 'assigned', 'in_progress', 'awaiting_confirmation', 'completed', 'raise_dispute', 'cancelled'];

/* ══════════ MAIN ══════════ */
const MyJobs = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);

  const [bids, setBids] = useState([]);
  const [activeTab, setActive] = useState('All');
  const [lightbox, setLightbox] = useState(null);
  const [reviews, setReviews] = useState({});
  const [loadingJobId, setLoadingJobId] = useState(null);
  const [loadingAction, setLoadingAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [disputeFor, setDisputeFor] = useState(null);
  const [disputeLoading, setDisputeLoading] = useState(false);
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [conversationId, setConversationId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [jobReviews, setJobReviews] = useState({});

  const [reviewFor, setReviewFor] = useState(null);
  const [bidsModalFor, setBidsModalFor] = useState(null);
  const customer = JSON.parse(localStorage.getItem("customer"));
  const customerId = customer?.id;
  const location = useLocation();

  const [loadingJobs, setLoadingJobs] = useState(true);
const [jobsLoading, setJobsLoading] = useState(false);

  /* ── API ── */
const viewPostedJobs = async (statusFilter = "All") => {

  const authToken = localStorage.getItem("authToken");

  try {

    const res = await axios.get(
      `${baseUrl}/customer/viewpostedjobs`,
      {
        headers:{
          Authorization:`Bearer ${authToken}`
        },
        params:{
          status:statusFilter
        }
      }
    );


   const jobs = res.data.postjobs || [];

setBids(jobs);


if(statusFilter === "All"){
   setAllJobs(jobs);
}


  } 
  catch(err){
    console.log(err);
  }
  finally{
    setLoading(false);
  }

};





  const refresh = () => viewPostedJobs(activeTab);

  /* ── Confirm ── */
  const handleConfirm = (id) => {
    setLoadingJobId(id);
setLoadingAction("confirm");
    const authToken = localStorage.getItem('authToken');
    axios.post(`${baseUrl}/customer/completejob`, { job_id: id },
      { headers: { Authorization: `Bearer ${authToken}` } })
      .then(() => refresh())
      .catch(err => console.log(err.response?.data || err.message))
       .finally(() => {
    setLoadingJobId(null);
    setLoadingAction("");
  });
  };

  /* ── Conversation create ── */
  const createConversation = (job) => {
    const authToken = localStorage.getItem('authToken');
    return axios.post(
      `${baseUrl}/customer/createconversation`,
      { job_id: job.id, message: job.description },
      { headers: { Authorization: `Bearer ${authToken}` } }
    );
  };

  /* ── Dispute submit ── */
  const handleDisputeSubmit = async (e, onClose, success, job, category, description) => {
    e.preventDefault();
    const authToken = localStorage.getItem('authToken');
setLoadingJobId(job.id);
setLoadingAction("dispute");

    try {
      const response = await axios.post(
        `${baseUrl}/customer/helpsupport`,
        {
          job_id: job.id,
          worker_id: job.whserviceprovider?.id,
          category,
          description,
          raisedby: 'customer',
          against: 'worker'
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      console.log(response.data);
      const conversationId = response.data.conversation_id;

      navigate(`/chat/${conversationId}`, { state: { description } });
      onClose();
      success();
    } catch (err) {
      console.log(err);
      alert("Server Error");
    } finally {
          setLoadingJobId(null);
    setLoadingAction("");

    }
  };

  /* ── Open dispute chat ── */
  const openDisputeChat = async (job) => {
    const authToken = localStorage.getItem('authToken');
    console.log(job);
    navigate(`/chat/${job.whconversation?.id}`, { state: { description: job.description } });
  };

  /* ── Status counts ── */
  const getStatusCounts = (jobs = []) => {
    const counts = {};
    jobs.forEach(job => {
      const st = job.status || 'pending';
      counts[st] = (counts[st] || 0) + 1;
    });
    return counts;
  };

const statusCounts = getStatusCounts(allJobs);
  /* ── Review ── */
  const handleReview = (job) => {
    setLoadingJobId(job.id);
setLoadingAction("review");
    const authToken = localStorage.getItem('authToken');
    const r = reviews[job.id] || {};

    const formData = new FormData();
    formData.append('whpostjob_id', job.id);
    formData.append('customerrating', r.rating);
    formData.append('customerreview', r.text);
    formData.append('whcustomer_id', job.whcustomer?.id || '');
    formData.append('whserviceprovider_id', job.whserviceprovider?.id || '');

    axios.post(
      `${baseUrl}/customer/jobreview`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    
      .then((res) => {
        console.log(res.data);
        handleConfirm(job.id);
      })
      .catch((err) => {
        console.log(err.response?.data || err.message)
        
      })
      .finally(() => {
    setLoadingJobId(null);
    setLoadingAction("");
});
  };

  /* ── Fetch review ── */
  const fetchReview = (jobId) => {
    const authToken = localStorage.getItem('authToken');

    axios.get(`${baseUrl}/viewreviews/${jobId}`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then(res => {
        const data = res.data || {};
        setJobReviews(prev => ({
          ...prev,
          [jobId]: {
            customer: data.customer_review
              ? {
                rating: data.customer_review.customerrating,
                review: data.customer_review.customerreview
              }
              : null,
            worker: data.worker_review
              ? {
                rating: data.worker_review.workerrating,
                review: data.worker_review.workerreview
              }
              : null
          }
        }));
      })
      .catch(err => console.log(err.message));
  };

  useEffect(() => {
    const completedJobs = bids.filter(j => j.status === 'completed');
    completedJobs.forEach(job => { fetchReview(job.id); });
  }, [bids]);

  const setReviewField = (id, key, val) =>
    setReviews(prev => ({ ...prev, [id]: { ...(prev[id] || {}), [key]: val } }));

  /* ── Accept bid ── */
 const handleAcceptBid = async (bidId) => {

setLoadingJobId(bidId);
setLoadingAction("acceptBid");


try {


const res = await axios.post(
`${baseUrl}/customer/acceptbid`,
{
bid_id: bidId
},
{
headers:{
Authorization:`Bearer ${localStorage.getItem('authToken')}`
}
}
);


if(res.data.success){


const stripeResponse = await axios.post(
`${baseUrl}/customer/payment`,
{
job_id: res.data.job_id,
bid_id: res.data.bid_id
},
{
headers:{
Authorization:`Bearer ${localStorage.getItem('authToken')}`
}
}
);


if(stripeResponse.data.success){

window.location.href =
stripeResponse.data.checkout_url;

}


}


}
catch(err){

console.log(err.response?.data);

}
finally{

setLoadingJobId(null);
setLoadingAction("");

}

}

  /* ── Cancel job ── */
  const handleCancel = (id) => {
    setLoadingJobId(id);
setLoadingAction("cancel");
    const authToken = localStorage.getItem('authToken');
    axios.post(`${baseUrl}/customer/canceljob`, { job_id: id },
      { headers: { Authorization: `Bearer ${authToken}` } }
    )
      .then(() => refresh())
      .catch(err => console.log(err.response?.data || err.message))
      .finally(() => {
    setLoadingJobId(null);
    setLoadingAction("");
});
  };

  console.log("Customer Object:", customer);
  console.log("Customer ID:", customerId);
  // sockets 
  useEffect(() => {

    console.log("Socket useEffect Called");

    if (!customerId) {
      console.log("Customer ID Missing");
      return;
    }

    console.log("Joining:", `customer-${customerId}`);

    const channel = echo.channel(`customer-${customerId}`);

    channel.subscribed(() => {
      console.log("Subscribed");
    });

    
channel.listen(".JobStatusUpdated", (event)=>{
    console.log("EVENT RECEIVED",event);

    viewPostedJobs("All");
});    

    return () => {
      echo.leave(`customer-${customerId}`);
    };

  }, [customerId, activeTab]);

  useEffect(() => {
    viewPostedJobs(activeTab);
  }, [activeTab]);


  if (loading) {
  return <MyJobsSkeleton />;
}
  /* ══════════ RENDER ══════════ */
  return (
    <>
      <AppNavbar />
    <>

      <div className="mbid-page">

        {/* ── Header ── */}
        <div className="mbid-header">
          <button className="mbid-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>
          <h2 className="mbid-title">My Jobs</h2>
        </div>

        {/* ── Tabs ── */}
        <div className="mbid-tabs">
          {TABS.map(t => {
const count = t === 'All' ? allJobs.length : (statusCounts[t] || 0);
            return (
              <button
                key={t}
                className={'mbid-tab' + (activeTab === t ? ' mbid-tab--active' : '')}
                onClick={() => setActive(t)}
              >
                {t === 'All' ? 'All' : (status[t]?.label || t)}
                <span className="mbid-tab__count">{count}</span>
              </button>
            );
          })}
        </div>

        {/* ── List ── */}
        <div className="mbid-list">

          {bids.length === 0 ? (

            <div className="mbid-empty">
              <div className="mbid-empty-icon">
                <ClipboardList size={55} />
              </div>
              <p>No jobs in this status.</p>
            </div>

          ) : (

            bids.map((b) => (
              <JobCard
                key={b.id}
                b={b}
                baseUrlForFile={baseUrlForFile}
                reviews={reviews}
                jobReviews={jobReviews}
                setLightbox={setLightbox}
                setBidsModalFor={setBidsModalFor}
                handleCancel={handleCancel}
                setDisputeFor={setDisputeFor}
                setReviewFor={setReviewFor}
                openDisputeChat={openDisputeChat}
                loadingJobId={loadingJobId}
                loadingAction={loadingAction}
                setLoadingJobId={setLoadingJobId}
                setLoadingAction={setLoadingAction}
              />
            ))

          )}

        </div>

      </div>
          </>

      {/* ── Dispute Modal ── */}
      {disputeFor && (
        <DisputeModal
          onClose={() => setDisputeFor(null)}
          job={disputeFor}
          success={() => {
            refresh();
            setActive('raise_dispute');
          }}
          onSubmit={handleDisputeSubmit}
        />
      )}

      {/* ── Review Modal ── */}
      {reviewFor && (
        <ReviewModal
          onClose={() => setReviewFor(null)}
          jobId={reviewFor.id}
          reviewData={reviews[reviewFor.id]}
          onReviewChange={setReviewField}
          onSubmit={() => {
            handleReview(reviewFor);
            setReviewFor(null);
          }}
        />
      )}

      {/* ── Bids Modal ── */}
      {bidsModalFor && (
        <BidsModal
          bids={bidsModalFor.whplacebids || []}
          onClose={() => setBidsModalFor(null)}
          onAccept={handleAcceptBid}
        />
      )}

      <Lightbox item={lightbox} onClose={() => setLightbox(null)} />
    </>
  );
};

export default MyJobs;